import React from 'react'
import Stack from '@mui/material/Stack'
import { Loader } from '@carsys/ui'
import { AutoHeightProvider } from '@cbgms/components/list/AutoHeightProvider'

interface Props {}

export const Layout: React.FC<Props> = ({ children }) => {
  const [observedElement, setObservedElement] = React.useState<HTMLDivElement | null>(null)

  return (
    <AutoHeightProvider paddingBottom={16} observedElement={observedElement}>
      <Stack sx={{ height: 'calc(100vh - 75px)' }} direction='column' flex={1} spacing={1} p={1} ref={setObservedElement}>
        <Stack flexGrow={1}>
          <React.Suspense fallback={<Loader loading fading />}>{children}</React.Suspense>
        </Stack>
      </Stack>
    </AutoHeightProvider>
  )
}
